var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "main-header" }, [
    _c("div", { staticClass: "main-header__banner" }, [
      _c("a", {
        staticClass: "main-header__logo",
        attrs: { href: _vm.pageOnLogin, "aria-label": "main header logo" }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }